import { TBuild, TypeOfBuild } from '@/types';

export interface eventThatDOESHaveValue {
  target: {
    value: string;
  };
}

export function isManaged(build: TBuild | TBuild): boolean {
  return (
    build.buildType === TypeOfBuild.ORG_THEME ||
    build.buildType === TypeOfBuild.OLIVER_THEME ||
    build.buildType === TypeOfBuild.OLIVER_GLOBAL_BLOCK ||
    build.buildType === TypeOfBuild.ORG_GLOBAL_BLOCK
  );
}

export function getHighestVersion(versions: string[] | undefined | null): number[] | null {
  if (versions && versions.length > 0) {
    let highestVersion = [0, 0, 0];
    versions.forEach((version) => {
      const versionArray = version.split('.').map((value) => {
        return parseInt(value);
      });
      if (versionArray && versionArray.length === 3) {
        if (versionArray[0] > highestVersion[0]) {
          highestVersion = versionArray;
        } else if (versionArray[0] === highestVersion[0]) {
          if (versionArray[1] > highestVersion[1]) {
            highestVersion = versionArray;
          } else if (versionArray[1] === highestVersion[1]) {
            if (versionArray[2] > highestVersion[2]) {
              highestVersion = versionArray;
            }
          }
        }
      }
    });
    return highestVersion;
  }
  return null;
}

export function findLatestBuildVersion(buildId: string, buildsAllversions: TBuild[]) {
  const allVersionsOfBuild = buildsAllversions.filter((build) => build.sourceId === buildId);
  const latestVersion = getHighestVersion(
    allVersionsOfBuild.map((build) => build.version || '0.0.0'),
  );

  return latestVersion?.join('.');
}

export function latestPublishedBuild(buildId: string, buildsAllversions: TBuild[]) {
  const allVersionsOfBuild = buildsAllversions.filter((build) => build.sourceId === buildId);
  const latestVersion = getHighestVersion(
    allVersionsOfBuild.map((build) => build.version || '0.0.0'),
  );

  return buildsAllversions.find(
    (build) =>
      build.sourceId === buildId && build.version === latestVersion?.join('.') && build.isPublished,
  );
}
